import React from "react";
import { Link } from "@mui/material";

export const FundLink = (row: number, value: string) => {
  const url = `/funds/detail/${row}`;
  return <Link href={url}>{value}</Link>;
};
